module.exports = __webpack_public_path__ + "img/launcher_kitkitschool_logo_sw.19bbdbc6.png";